// src/components/SuccessPage.jsx
import { CheckCircle, Home, Check } from 'lucide-react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const SuccessPage = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Read reference number from URL query param
    const queryParams = new URLSearchParams(location.search);
    const referenceNumber = queryParams.get('ref') || '';
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'auto'
        });
    }, []);
    return (
        <div className="min-h-screen bg-gradient-to-br from-primary/10 via-white to-primary/10 flex items-center justify-center p-6">
            <div className="max-w-2xl w-full text-center space-y-8">
                {/* Success Icon */}
                <div className="flex justify-center">
                    <div className="relative">
                        <div className="w-28 h-28 bg-green-100 rounded-full flex items-center justify-center animate-pulse">
                            <CheckCircle className="w-20 h-20 text-green-600" strokeWidth={2} />
                        </div>
                        <div className="absolute -bottom-2 -right-2 w-12 h-12 bg-green-600 rounded-full flex items-center justify-center border-4 border-white shadow-lg">
                            <Check className="w-7 h-7 text-white" strokeWidth={3} />
                        </div>
                    </div>
                </div>

                {/* Main Message */}
                <div className="space-y-4">
                    <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
                        Registration Successful!
                    </h1>
                    <p className="text-xl text-gray-700 max-w-lg mx-auto">
                        Thank you for submitting your provider empanelment request.
                    </p>
                    <p className="text-lg text-gray-600">
                        Our team is reviewing your application. You will be notified via email once your registration is approved.
                    </p>
                </div>

                {/* Status Card */}
                <div className="bg-white border-2 border-green-200 rounded-3xl p-8 shadow-xl max-w-lg mx-auto">
                    <div className="space-y-6">
                        <div className="flex items-center justify-center gap-4">
                            <div className="w-14 h-14 bg-green-100 rounded-full flex items-center justify-center">
                                <CheckCircle className="w-8 h-8 text-green-600" />
                            </div>
                            <div className="text-left">
                                <h3 className="text-xl font-semibold text-gray-900">Application Received</h3>
                            </div>
                        </div>

                        <div className="border-t border-gray-200 pt-6">
                            <p className="text-gray-700 text-lg">
                                Your Reference number: <span className="font-bold text-green-700 text-xl">
                                    {referenceNumber}
                                </span>
                            </p>
                        </div>
                    </div>
                </div>



                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-4 justify-center pt-6">


                    <button
                        onClick={() => navigate('/')}
                        className="flex items-center justify-center gap-3 px-8 py-4 bg-white border-2 border-gray-300 text-gray-700 font-semibold rounded-full hover:border-primary hover:text-primary transition-all shadow-md"
                    >
                        <Home size={20} />
                        Back to Home
                    </button>
                </div>

                {/* Support Note */}
                <p className="text-sm text-gray-600 pt-8">
                    Need help? Contact our support team at{' '}
                    <a href="mailto:providernetworkuae@fmchealthcare.ae" className="text-primary hover:underline font-medium">
                        providernetworkuae@fmchealthcare.ae
                    </a>
                </p>
            </div>
        </div>
    );
};

export default SuccessPage;